// Procedural cloud sprite atlas (2x2 tiles). Generated once during the loading screen.
function makeNoise(seed) {
  const perm = new Uint8Array(512);
  let s = seed;
  const rnd = () => { s = (s * 16807 + 0) % 2147483647; return s / 2147483647; };
  const p = Array.from({ length: 256 }, (_, i) => i);
  for (let i = 255; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [p[i], p[j]] = [p[j], p[i]]; }
  for (let i = 0; i < 512; i++) perm[i] = p[i & 255];
  const fade = (t) => t * t * (3 - 2 * t);
  const grad = (h, x, y) => { switch (h & 3) { case 0: return x + y; case 1: return -x + y; case 2: return x - y; default: return -x - y; } };
  return (x, y) => {
    const X = Math.floor(x) & 255, Y = Math.floor(y) & 255;
    x -= Math.floor(x); y -= Math.floor(y);
    const u = fade(x), v = fade(y);
    const a = perm[X + perm[Y]], b = perm[X + 1 + perm[Y]], c = perm[X + perm[Y + 1]], d = perm[X + 1 + perm[Y + 1]];
    const l1 = grad(a, x, y) + u * (grad(b, x - 1, y) - grad(a, x, y));
    const l2 = grad(c, x, y - 1) + u * (grad(d, x - 1, y - 1) - grad(c, x, y - 1));
    return l1 + v * (l2 - l1);
  };
}

function fbm(noise, x, y, oct) {
  let v = 0, amp = 0.5, f = 1;
  for (let i = 0; i < oct; i++) { v += amp * noise(x * f, y * f); amp *= 0.5; f *= 2.1; }
  return v;
}

export function generateCloudAtlas(tile = 512) {
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = tile * 2;
  const g = canvas.getContext('2d');
  const variants = [
    { seed: 11, sx: 1.0, sy: 0.72, thr: 0.32, soft: 0.42 },
    { seed: 29, sx: 1.0, sy: 0.9, thr: 0.36, soft: 0.4 },
    { seed: 47, sx: 1.0, sy: 0.5, thr: 0.3, soft: 0.5 },
    { seed: 83, sx: 0.9, sy: 0.8, thr: 0.4, soft: 0.36 },
  ];
  variants.forEach((v, idx) => {
    const noise = makeNoise(v.seed);
    const img = g.createImageData(tile, tile);
    const d = img.data;
    for (let j = 0; j < tile; j++) {
      for (let i = 0; i < tile; i++) {
        const u = i / tile - 0.5, w = j / tile - 0.5;
        const edge = fbm(noise, u * 3 + 7, w * 3 + 3, 3) * 0.28;
        const r = Math.sqrt((u / (0.46 * v.sx)) ** 2 + (w / (0.46 * v.sy)) ** 2) + edge;
        const fall = Math.max(0, 1 - r);
        const n = fbm(noise, u * 4.5, w * 4.5, 5) * 0.5 + 0.5;
        let a = fall * (n * 1.35 + 0.15);
        a = Math.min(1, Math.max(0, (a - v.thr) / v.soft));
        a = a * a * (3 - 2 * a);
        // Hard window so no alpha ever reaches the tile border (prevents quad-edge artifacts)
        const wx = Math.min(1, Math.max(0, (0.5 - Math.abs(u)) / 0.1)), wy = Math.min(1, Math.max(0, (0.5 - Math.abs(w)) / 0.1));
        a *= wx * wx * (3 - 2 * wx) * wy * wy * (3 - 2 * wy);
        const k = (j * tile + i) * 4;
        d[k] = d[k + 1] = d[k + 2] = 255;
        d[k + 3] = Math.round(a * 255);
      }
    }
    g.putImageData(img, (idx % 2) * tile, Math.floor(idx / 2) * tile);
  });
  return canvas;
}
